const DEFAULT_MENU_BASE_URL = "https://live.layerbound.com";

const normalizeMenuBaseUrl = (value) => {
  if (!value || typeof value !== "string") {
    return DEFAULT_MENU_BASE_URL;
  }
  const trimmed = value.trim();
  if (!trimmed) {
    return DEFAULT_MENU_BASE_URL;
  }
  const withoutTrailingSlash = trimmed.endsWith("/") ? trimmed.slice(0, -1) : trimmed;
  // If legacy configs still include the deprecated /menus suffix, strip it.
  const legacySuffix = "/menus";
  if (withoutTrailingSlash.endsWith(legacySuffix)) {
    const stripped = withoutTrailingSlash.slice(0, -legacySuffix.length) || DEFAULT_MENU_BASE_URL;
    return stripped.endsWith("/") ? stripped.slice(0, -1) : stripped;
  }
  return withoutTrailingSlash;
};

export const resolveMenuBaseUrl = (menuBaseUrlFromConfig) =>
  normalizeMenuBaseUrl(menuBaseUrlFromConfig);

export const getMenuBaseDisplay = (menuBaseUrlFromConfig) =>
  resolveMenuBaseUrl(menuBaseUrlFromConfig).replace(/^https?:\/\//, "");

export const DEFAULT_MENU_DOMAIN = DEFAULT_MENU_BASE_URL;
